export default __webpack_public_path__ + "static/paul-apostu-6c419302662d79281393f2cd30ff19fc.svg";